import script from "./RacPendenteTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RacPendenteTabPage.vue?vue&type=script&setup=true&lang=js"

import "./RacPendenteTabPage.vue?vue&type=style&index=0&id=cff8a774&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cff8a774"]])

export default __exports__